/**
 * user_id % 8 결정적 색상 (ux-workchat-v1.md §4.3, P2-15b SSOT).
 *
 * 같은 사용자는 어느 화면에서도 같은 아바타 색을 갖도록 한다.
 * 시안 themes 의 primary 색군 — primary-40 톤을 사용해 가독성 보장.
 */

const PALETTE = [
  'hsl(212, 80%, 55%)', // blue
  'hsl(263, 80%, 60%)', // purple
  'hsl(142, 70%, 45%)', // green
  'hsl(28, 90%, 55%)',  // orange
  'hsl(330, 80%, 60%)', // pink
  'hsl(180, 70%, 45%)', // teal
  'hsl(48, 95%, 50%)',  // amber
  'hsl(0, 75%, 55%)',   // red
] as const;

export function useDeterministicColor(userId: number): string {
  const idx = ((userId % PALETTE.length) + PALETTE.length) % PALETTE.length;
  return PALETTE[idx]!;
}
